<template>
    <div component="Shortlist">
        <page-header :icon="'equalizer'" :text="'SHORTLIST RATING'" :hasCloseButton="true"></page-header>
        <section container="detail">
            <scroll-table v-if="getActor" :list="getActorShortList" :config="getActorStatsTableConfig"></scroll-table>
        </section>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import ScrollTable from '@/components/.global/ScrollTable/ScrollTable.vue';

export default {
    components: {
        PageHeader,
        ScrollTable,
    },

    name: 'Shortlist',

    computed: {
        ...mapGetters(['getActor', 'getActorShortList', 'getActorStatsTableConfig']),
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Shortlist'] {
    [container='detail'] {
        padding-top: 15px;
    }
}
</style>
